import { useMemo } from 'react';

import TextDisplayBlock from '@apigrowfinance/pbolt-text-display-block';
import { useIntl } from 'react-intl';

import { GetCardControlsConditionsResponse } from '@clients/domains/flexControls/flexControlAccountClient';
import { toTitleCase } from '@utils/string/caseUtils';

interface ControlConditionsBlockItemProps {
    cardControlItem: GetCardControlsConditionsResponse;
    isLoading?: boolean;
    noColumnsPerRow: number;
}

const ControlConditionsBlockItem = ({
    cardControlItem,
    isLoading,
    noColumnsPerRow,
}: ControlConditionsBlockItemProps) => {
    const { formatMessage } = useIntl();

    const textBlocks = useMemo(() => {
        return [
            {
                label: formatMessage({
                    id: 'ControlConditionsBlockItem.conditionId',
                    defaultMessage: 'Condition ID',
                }),
                value: toTitleCase(cardControlItem?.id),
            },
            {
                label: formatMessage({
                    id: 'ControlConditionsBlockItem.attribute',
                    defaultMessage: 'Attribute',
                }),
                value: toTitleCase(cardControlItem?.attribute),
            },
            {
                label: formatMessage({
                    id: 'ControlConditionsBlockItem.operator',
                    defaultMessage: 'Operator',
                }),
                value: toTitleCase(cardControlItem?.operator),
            },

            {
                label: formatMessage({
                    id: 'ControlConditionsBlockItem.value',
                    defaultMessage: 'Value',
                }),
                value: toTitleCase(cardControlItem?.value),
            },
        ];
    }, [cardControlItem, formatMessage]);

    return (
        <TextDisplayBlock
            isLoading={isLoading}
            textBlocks={textBlocks}
            noOfColumnsPerRow={noColumnsPerRow}
        />
    );
};

export default ControlConditionsBlockItem;
